import NoteIcon from '@material-ui/icons/Note';
import PostList from './PostList';
import AddPost from './PostCreate';
import EditPost from './PostEdit';
import ShowPost from './PostView';

export default {
  list: PostList,
  create: AddPost,
  edit: EditPost,
  show: ShowPost,
  icon: NoteIcon,
};
